// extracted by mini-css-extract-plugin
module.exports = {"name":"_2HhToiAm6LcHTZKPfR1avt","capacity":"I8qEXZIBFm2Zl10JqB6p","pricing":"_1BxaCVMDjexySn2GdS7N2-"};